<section class="design-area">
    <div class="container">
        <div class="row">
            <div class="col-xl-12 text-center">
                <div class="section-title ">
                    <img lazyLoad="assets/img/contact_banner.jpg">
                    <!-- <img lazyLoad="https://gujarattilesinfo.com/assets/img/line.svg" width="120"> -->
                </div>
            </div>
            <div class="col-xl-12 text-center">
                <h3 class="contact-head">Contct Us</h3>
                <div class="about-p text-center">
                    <p>
                        <strong>Gujarat Tiles Info (GTI)</strong>, founded in <strong>2012</strong> and headquartered in <strong>Morbi, Gujarat</strong>, is a leading <strong>ceramic industry directory</strong> and <strong>B2B portal </strong>dedicated to India's thriving ceramic sector.

As a trusted platform, GTI seamlessly connects tile manufacturers, buyers, suppliers, and Service providers, streamlining business interactions and strengthening the supply chain within the ceramic ecosystem. Our mission is to <strong>drive innovation and empower the Indian ceramic industry</strong> by providing a centralized hub for growth, collaboration, and quality improvement.

GTI not only showcases the excellence of Indian ceramic products but also helps enhance your global competitiveness by building a vast network of committed industry professionals. Whether you are a manufacturer seeking exposure or a buyer looking for the best deals, GTI provides you with <strong>direct access to verified contacts</strong> and resources to support your business objectives.

From industry information to product listings, GTI stands out as a <strong>one-stop destination</strong> for all things ceramics—your ideal partner for driving better business internationally.
                    </p>
                </div>
            </div>
        </div>

    <div class="gti_ban_neew">
        <div class="row mt-5">
                <div class="col-xl-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="text-center gti_cont_ban_sec">                   
                            <div class="gti_cont_side_ban gti_cont_side_ban3">
                                <h3><i class="fa fa-phone" aria-hidden="true"></i></h3>
                                <h2 class="">Call Us</h2>
                            </div>
                            <p><span>Customer Care :</span> +91 90990 89071</p>
                            <p><span>Director Contact no : </span>+91 89800 70086</p>                    
                        <!-- <span>+91 90990 89071, +91 90990 89071</span> -->
                    </div>
                </div>
                <div class="col-xl-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="text-center gti_cont_ban_sec">
                       
                            <div class="gti_cont_side_ban gti_cont_side_ban3">
                                <h3><i class="fa fa-envelope" aria-hidden="true"></i></h3>
                                <h2 class="">Contact Us</h2>
                            </div>
                            <div class="ms-3 gti_cont_side_ban2">
                                <!-- <p>Gujarat Tiles Info is ceramic industry directory Info is ceramic industry directory  directory Info is ceramic industry directory</p> -->
                               <p><span (click)="addAtSymbol()">gti.directory&#64;gmail.com</span></p> 
                                <p><span (click)="addAtSymbol()">Info&#64;gujarattilesinfo.com</span></p>
                                <p><span (click)="addAtSymbol()">gujarattilesinfo&#64;gmail.com</span></p>
                                <!-- <button >Add &#64;</button> -->
                            </div>
                         </div>                    
                </div>
        </div>
    </div>
<div class="row mt-5">

            <div class="col-xl-12 col-md-12 col-sm-12 col-xs-12">
                <div class="text-start gti_cont_ban_sec gti_cont_ban_sec_bef" >
                    <div class="d-flex">
                        <div class="gti_cont_side_ban">

                            <h3><i class="fa fa-home" aria-hidden="true"></i></h3>
                            <h2 class="">Visit Us</h2>
                        </div>

                        <p> <span>Address</span>227 Dariyalal Square , Nr. Bhaktinagar bypass , Shanala road - Morbi-363641</p>
                        <p> <span>Registered Address</span> Shop No. 13 to 25 Plot No.1 Marutipark,Nr.Lords Hotel ,Jetpar Ppili road , Pipli, Morbi -363642</p>
                        <p> <span>Gandhinagar Branch Address</span>office No. 9 ,Sector 9 Nr. Sarita udhyan -Gandhinagar</p>
                    </div>
                    <!-- <span>123 Colony XyZ, Morbi Gujarat 363641</span> -->
                </div>
            </div>
          

            <!-- <div class="col-xl-6 col-md-6 col-sm-4 col-xs-12">
                <div class="about-p">
                    <p>Gujarat Tiles Info is ceramic industry directory. We provide community for Tiles Manufacturers,
                        Tiles Dealers, Sanitary Manufacturers, Importer, Exporter, Raw Material Suppliers, Transporters,
                        Ceramic industry related manufacturer all information at one place.</p>
                </div>
            </div> -->
            
            
            
        </div>
    </div>
</section>
